<template>
  <div>
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title" style="color#fff">
            {{ name }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile
        value="true"
        v-for="(item, i) in items"
        :key="i"
        :to="item.route"
        class="tile"
      >
        <v-list-tile-action>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: "Accountant",
      items: [
        { title: 'Dashboard', icon: 'dashboard', route: { name: 'accountant.dashboard' } },
        { title: 'School Fees', icon: 'money', route: { name: 'accountant.fees' } },
        { title: 'Billings', icon: 'money', route: { name: 'accountant.billing' } },
        { title: 'Banking', icon: 'money', route: { name: 'accountant.banking' } },
        { title: 'Expenses', icon: 'money', route: { name: 'accountant.expenses' } },
        { title: 'Income', icon: 'money', route: { name: 'accountant.income' } },
        { title: 'Reports', icon: 'list', route: { name: 'accountant.reports' } },
        // { title: 'Payroll', icon: 'people', route: { name: 'accountant.payroll' } },

        { title: 'My Account', icon: 'account_box', route: { name: 'settings.profile' } }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenus/Accounts.vue